import React from 'react'
const Common = React.createContext({auth: null});

export default Common
